// import { Recipe, RecipeRequest, RecipeResponse } from '@/types';
// import { apiClient } from './api';

// const createRecipeFormData = (recipeData: any, imageFile?: File): FormData => {
//     const formData = new FormData();

//     // Agregar datos de la receta como JSON
//     const recipePayload = {
//         title: recipeData.title,
//         time: recipeData.time,
//         difficulty: recipeData.difficulty,
//         category: recipeData.category,
//         calories: parseInt(recipeData.calories),
//         protein: parseInt(recipeData.protein),
//         carbs: parseInt(recipeData.carbs),
//         fat: parseInt(recipeData.fat),
//         tags: recipeData.tags || [],
//         ingredients: recipeData.ingredients || [],
//         instructions: recipeData.instructions || '',
//         isPublic: recipeData.isPublic || false
//     };

//     formData.append('recipe', new Blob([JSON.stringify(recipePayload)], {
//         type: 'application/json'
//     }));

//     // Agregar archivo de imagen si existe
//     if (imageFile) {
//         formData.append('imageFile', imageFile);
//     }

//     return formData;
// };

// export const recipeService = {
//     // Obtener todas las recetas (públicas + del usuario)
//     async getRecipes(token: string): Promise<RecipeResponse[]> {
//         return apiClient.get('/recipes', token);
//     },

//     // Obtener recetas públicas
//     async getPublicRecipes(): Promise<RecipeResponse[]> {
//         return apiClient.get('/recipes/public');
//     },

//     // Obtener recetas del usuario actual
//     async getUserRecipes(token: string): Promise<RecipeResponse[]> {
//         return apiClient.get('/recipes/user', token);
//     },

//     // Obtener receta por ID
//     async getRecipeById(id: number, token: string): Promise<RecipeResponse> {
//         return apiClient.get(`/recipes/${id}`, token);
//     },

//     // Crear nueva receta
//     async createRecipe(recipeData: any, token: string, imageFile?: File): Promise<RecipeResponse> {
//         const formData = createRecipeFormData(recipeData, imageFile);

//         const response = await fetch('http://localhost:8081/api/recipes', {
//             method: 'POST',
//             headers: {
//                 'Authorization': `Bearer ${token}`
//             },
//             body: formData
//         });

//         if (!response.ok) {
//             const errorText = await response.text();
//             throw new Error(errorText || 'Error creating recipe');
//         }

//         return response.json();
//     },

//     // Actualizar receta
//     async updateRecipe(id: number, recipeData: RecipeRequest, token: string): Promise<RecipeResponse> {
//         return apiClient.put(`/recipes/${id}`, recipeData, token);
//     },

//     // Eliminar receta
//     async deleteRecipe(id: number, token: string): Promise<boolean> {
//         return apiClient.delete(`/recipes/${id}`, token);
//     },

//     // Filtrar recetas por categoría
//     async getRecipesByCategory(category: string, token: string): Promise<RecipeResponse[]> {
//         return apiClient.get(`/recipes/category/${category}`, token);
//     },

//     // Buscar recetas
//     async searchRecipes(query: string, token: string): Promise<RecipeResponse[]> {
//         return apiClient.get(`/recipes/search?q=${encodeURIComponent(query)}`, token);
//     },

//     // Obtener recetas filtradas por preferencias del usuario
//     async getFilteredRecipes(token: string): Promise<RecipeResponse[]> {
//         return apiClient.get('/recipes/filtered', token);
//     }
// };
import { Recipe, RecipeRequest, RecipeResponse } from '@/types';
import { apiClient } from './api';

const createRecipeFormData = (recipeData: any, imageFile?: File): FormData => {
    const formData = new FormData();

    // Agregar datos de la receta como JSON
    const recipePayload = {
        title: recipeData.title,
        time: recipeData.time,
        difficulty: recipeData.difficulty,
        category: recipeData.category,
        calories: parseInt(recipeData.calories),
        protein: parseInt(recipeData.protein),
        carbs: parseInt(recipeData.carbs),
        fat: parseInt(recipeData.fat),
        tags: recipeData.tags || [],
        ingredients: recipeData.ingredients || [],
        instructions: recipeData.instructions || '',
        isPublic: recipeData.isPublic || false
    };

    formData.append('recipe', new Blob([JSON.stringify(recipePayload)], {
        type: 'application/json'
    }));

    // Agregar archivo de imagen si existe
    if (imageFile) {
        formData.append('imageFile', imageFile);
    }

    return formData;
};

const getImageUrl = (imagePath: string | null | undefined): string => {
    if (!imagePath) {
        return 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80';
    }

    // Si ya es una URL completa
    if (imagePath.startsWith('http')) {
        return imagePath;
    }

    // ✅ CORREGIDO: Usar la misma lógica que imageUtils.ts
    const backendUrl = import.meta.env.PROD
        ? 'https://backendcomerbien-production.up.railway.app'
        : 'http://localhost:8081';

    // Manejar diferentes formatos de imagePath
    if (imagePath.startsWith('/api/files/')) {
        return `${backendUrl}${imagePath}`;
    }

    // Si es solo un UUID o nombre de archivo
    return `${backendUrl}/api/files/${imagePath}`;
};


export const recipeService = {
    // Obtener todas las recetas (públicas + del usuario)
    async getRecipes(token: string): Promise<RecipeResponse[]> {
        console.log('🌐 Fetching ALL recipes (requires auth)...');
        return apiClient.get('/recipes', token);
    },

    // Obtener solo recetas públicas - no requiere autenticación
    async getPublicRecipes(): Promise<RecipeResponse[]> {
        console.log('🌐 Fetching PUBLIC recipes only...');
        return apiClient.get('/recipes/public');
    },

    // Obtener recetas del usuario actual
    async getUserRecipes(token: string): Promise<RecipeResponse[]> {
        return apiClient.get('/recipes/user', token);
    },

    // Obtener receta por ID
    async getRecipeById(id: number, token: string): Promise<RecipeResponse> {
        return apiClient.get(`/recipes/${id}`, token);
    },

    // ✅ CORREGIDO: Crear nueva receta usando apiClient
    async createRecipe(recipeData: any, token: string, imageFile?: File): Promise<RecipeResponse> {
        try {
            console.log('🔄 Creating recipe with image:', !!imageFile);

            if (imageFile) {
                // Usar FormData cuando hay imagen
                const formData = createRecipeFormData(recipeData, imageFile);
                return await apiClient.upload('/recipes', formData, token);
            } else {
                // Usar JSON normal cuando no hay imagen
                const recipePayload = {
                    title: recipeData.title,
                    time: recipeData.time,
                    difficulty: recipeData.difficulty,
                    category: recipeData.category,
                    calories: parseInt(recipeData.calories),
                    protein: parseInt(recipeData.protein),
                    carbs: parseInt(recipeData.carbs),
                    fat: parseInt(recipeData.fat),
                    tags: recipeData.tags || [],
                    ingredients: recipeData.ingredients || [],
                    instructions: recipeData.instructions || '',
                    isPublic: recipeData.isPublic || false
                };
                return await apiClient.post('/recipes', recipePayload, token);
            }
        } catch (error) {
            console.error('❌ Error in recipeService.createRecipe:', error);
            throw error;
        }
    },

    // Actualizar receta
    async updateRecipe(id: number, recipeData: RecipeRequest, token: string): Promise<RecipeResponse> {
        return apiClient.put(`/recipes/${id}`, recipeData, token);
    },

    // Eliminar receta
    async deleteRecipe(id: number, token: string): Promise<boolean> {
        return apiClient.delete(`/recipes/${id}`, token);
    },

    // Filtrar recetas por categoría
    async getRecipesByCategory(category: string, token: string): Promise<RecipeResponse[]> {
        return apiClient.get(`/recipes/category/${category}`, token);
    },

    // Buscar recetas
    async searchRecipes(query: string, token: string): Promise<RecipeResponse[]> {
        return apiClient.get(`/recipes/search?q=${encodeURIComponent(query)}`, token);
    },

    // Obtener recetas filtradas por preferencias del usuario
    async getFilteredRecipes(token: string): Promise<RecipeResponse[]> {
        return apiClient.get('/recipes/filtered', token);
    }
};

export { getImageUrl };